import React from 'react';
import { Arrow, PlayButton } from '..';

export const Controls = ({
  show,
  showPrevious,
  onPreviousClick,
  onPlayClick,
  showNext,
  onNextClick
}) => show && (
  <div className="controls">
    <Arrow
      onClick={onPreviousClick}
      direction="left"
      show={showPrevious}
    />

    <PlayButton onClick={onPlayClick} />

    <Arrow
      onClick={onNextClick}
      direction="right"
      show={showNext}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Player/Controls.jsx